<template>
  <textarea :disabled="disabled" :rows="rows" :required="required" :id="id" class="input-base block w-full rounded-md"
            :placeholder="placeholder" :value="value" @input="input"/>
</template>

<script>
import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";

export default {
  name: "UiFormTextarea",
  setup: setup,
  mixins: [mixin],
  props: {
    rows: {
      default: 2,
    }
  }

}
</script>
